// creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
import React, { Component, PropTypes } from 'react';
import CloseX from '../../svgs/CloseX';

export default class ModalClose extends Component {
  static propTypes = {
    handleClose: PropTypes.func,
    removeState: PropTypes.any
  }

  constructor() {
    super();
    this.respondToKeyPress = ::this.respondToKeyPress;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.respondToKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.respondToKeyPress);
  }

  respondToKeyPress(event) {
    // escape key response
    if(event.keyCode === 27 && this.props.handleClose) {
      this.props.handleClose();
    }
  }

  render() {
    return (
      <div
        className='worksheet-toolbar-item right'
        data-id='Close'
        onClick={this.props.handleClose}>
        Close
        <CloseX style={{color: '#fff'}}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/ModalClose/index.js